import { render, staticRenderFns } from "./projectSearch.vue?vue&type=template&id=35b43b6f&scoped=true&"
import script from "./projectSearch.vue?vue&type=script&lang=js&"
export * from "./projectSearch.vue?vue&type=script&lang=js&"
import style0 from "./projectSearch.vue?vue&type=style&index=0&id=35b43b6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b43b6f",
  null
  
)

export default component.exports